export const CAPABILITIES_LIMIT = 5000;
export const USERS_BY_ROLE_ID_QUERY_KEY = 'user-role-data';

export const PC_SHARING_DETAILS_KEYS = {
  createPoliciesPCId: 'createPCId',
  updatePoliciesPCId: 'updatePCId',
  createRolesPCIds: 'createPCIds',
  updateRolesPCIds: 'updatePCIds',
};
